import React, { Dispatch, ReactElement, SetStateAction } from 'react'
import { useTranslation } from 'next-i18next'

type QuantitySelectorProps = {
    quantity: number
    setQuantity: (qty: number) => void
    isEditingDisabled?: boolean
}

const MIN = 1
const MAX = 99

const getBoundedValue = (value = 0): number => {
    if (value > MAX) return MAX
    if (value < MIN) return MIN
    return value
}

export const QuantitySelector = ({
    quantity,
    setQuantity,
    isEditingDisabled = false
}: QuantitySelectorProps): ReactElement => {
    const { t } = useTranslation('common')
    return (
        <div>
            {/* eslint-disable-next-line jsx-a11y/no-onchange */}
            <select
                id="qty"
                className="form-select qty-pdp mt-1.5"
                value={quantity}
                onChange={(e) => {
                    const newValue = getBoundedValue(+e.target.value)
                    setQuantity(newValue)
                    // sometimes state changes do not reflect the input value, therefore
                    //  value should be set explicitly
                    e.target.value = newValue.toString()
                }}
                disabled={isEditingDisabled}
            >
                {Array.from({ length: 99 }, (_, i) => (
                    <option key={i} value={i + 1}>
                        {i + 1}
                    </option>
                ))}
            </select>
        </div>
    )
}
